import { asyncActionCreators } from '../../utils/actions';

export const fetchStatistics = asyncActionCreators('FETCH_STATISTICS');
export const fetchCommonStatistics = asyncActionCreators('FETCH_COMMON_STATISTICS');



// WEBPACK FOOTER //
// ./src/sagas/statistics/actions.js